import React from "react";
import moment from "moment";
import SessionStore from "../../../stores/SessionStore";
import { DEFAULT_LDAP_USER_SEARCH_FILTER } from "../../../constants/LdapConstants";

import FlexibleTable from "../../../modules/FlexibleTable";
import ModalWindow from "../../../modules/ModalWindow";
import TableCentricPageButton from "../../../modules/TableCentricPageButton";
import Separator from "../../../modules/Separator";

import TableLeftPanel from "../../../utils/TableLeftPanel";
import TableCentricPage from "../../../modules/TableCentricPage";

import EditButton from "../../../modules/EditButton";
import DeleteButton from "../../../modules/DeleteButton";
import SearchableSelect from "../../../modules/SearchableSelect";

import "../../../../css/filtering.css";
import { Box, Button, Checkbox, InlineNotification, Link, Text } from "@familyzone/component-library";
import { Flex, Skeleton } from "@chakra-ui/react";
import LDAPServerPasswordInput from "./../LDAPServerPasswordInput";
import { MergeOptionsNoControl, UserMergeKey } from "./ConfigForm/MergeOptions";
import { formatString } from "./SyncStatus";
import { purgeSyncData } from "../../../utils/api/Purge";
import { PurgeConfirmModal } from "./ConfigForm/PurgeConfirmModal";
import {
  deleteSyncConfiguration,
  executeSync,
  extractSyncError,
  getLdapRun,
  listSyncConfigurations,
  mapStatusNode,
  SyncType,
  updateLdapSharedMergeConfig,
} from "../../../utils/api/SyncApi";
import { mapNodeToLdapServer, saveLdapServer } from "./ldapSyncMapper";
import { buildMergeConfig, mergeConfigToInput, mergeKeyFromConfig } from "./googleAzureSyncMapper";
import { DEFAULT_FAILURE_MESSAGE } from "../sis-integration/mapSyncNodeToSISProvider";

import { ConfigFormLabel } from "./ConfigForm/ConfigFormLabel";

class AddEditRule extends React.Component {
  constructor(props, context) {
    super(props, context);
    this.state = {
      ldap: this.props.ldap,
    };
    this.modalRef = React.createRef();
  }

  componentWillReceiveProps(nextprops) {
    this.setState({
      ldap: nextprops.ldap,
    });
  }

  handleHide = () => {
    this.props.handleClose();
  };

  handle_ChangeSync = (event) => {
    const ldap = this.state.ldap;
    ldap.sync_enabled = event.target.checked;
    this.setState({ ldap: ldap });
  };

  handle_ChangeSyncOUs = (event) => {
    const ldap = this.state.ldap;
    ldap.sync_ous = event.target.checked;
    this.setState({ ldap: ldap });
  };

  handle_ChangeSyncByDN = (event) => {
    const ldap = this.state.ldap;
    ldap.sync_by_dn = event.target.checked;
    this.setState({ ldap: ldap });
  };

  handle_ChangeEnabled = (event) => {
    const ldap = this.state.ldap;
    ldap.enabled = event.target.checked;
    this.setState({ ldap: ldap });
  };

  handle_ChangeAuthenticateUserUsingDn = (event) => {
    const ldap = this.state.ldap;
    ldap.authenticateuserusingsupplieddn = event.target.checked;
    this.setState({ ldap: ldap });
  };

  handle_ChangeMode = (event) => {
    const ldap = this.state.ldap;
    ldap.type = event.value;
    this.setState({ ldap: ldap });
  };

  handle_ChangeProtocol = (event) => {
    const ldap = this.state.ldap;
    ldap.protocol = event.value;
    this.setState({ ldap: ldap });
  };

  handle_ChangeUserOwnedGroupMembership = (event) => {
    const ldap = this.state.ldap;
    ldap.userownedgroupmembership = event.target.checked;
    this.setState({ ldap: ldap });
  };

  handle_ChangeUserNameAttribute = (event) => {
    const ldap = this.state.ldap;
    ldap.usernameattribute = event.target.value;
    this.setState({ ldap: ldap });
  };

  handle_ChangeManagerAttribute = (event) => {
    const ldap = this.state.ldap;
    ldap.managerattribute = event.target.value;
    this.setState({ ldap: ldap });
  };

  handle_ChangeEmailAttribute = (event) => {
    const ldap = this.state.ldap;
    ldap.emailattribute = event.target.value;
    this.setState({ ldap: ldap });
  };

  handle_ChangeUserBase = (event) => {
    const ldap = this.state.ldap;
    ldap.userbase = event.target.value;
    this.setState({ ldap: ldap });
  };

  handle_ChangeUserGroupAttribute = (event) => {
    const ldap = this.state.ldap;
    ldap.usergroupattribute = event.target.value;
    this.setState({ ldap: ldap });
  };

  handle_ChangeUserDnAttribute = (event) => {
    const ldap = this.state.ldap;
    ldap.userdnattribute = event.target.value;
    this.setState({ ldap: ldap });
  };

  handle_ChangeGroupDnAttribute = (event) => {
    const ldap = this.state.ldap;
    ldap.groupdnattribute = event.target.value;
    this.setState({ ldap: ldap });
  };

  handle_ChangeOuDnAttribute = (event) => {
    const ldap = this.state.ldap;
    ldap.oudnattribute = event.target.value;
    this.setState({ ldap: ldap });
  };

  handle_ChangeOuNameAttribute = (event) => {
    const ldap = this.state.ldap;
    ldap.ounameattribute = event.target.value;
    this.setState({ ldap: ldap });
  };

  handle_ChangeGroupBase = (event) => {
    const ldap = this.state.ldap;
    ldap.groupbase = event.target.value;
    this.setState({ ldap: ldap });
  };

  handle_ChangeGroupNameAttribute = (event) => {
    const ldap = this.state.ldap;
    ldap.groupnameattribute = event.target.value;
    this.setState({ ldap: ldap });
  };

  handle_ChangeGroupMemberNameAttribute = (event) => {
    const ldap = this.state.ldap;
    ldap.groupmembernameattribute = event.target.value;
    this.setState({ ldap: ldap });
  };

  handle_ChangeHostname = (event) => {
    const ldap = this.state.ldap;
    ldap.hostname = event.target.value;
    this.setState({ ldap: ldap });
  };

  handle_ChangePort = (event) => {
    const ldap = this.state.ldap;
    ldap.port = parseInt(event.target.value);
    this.setState({ ldap: ldap });
  };

  handle_ChangeBaseDN = (event) => {
    const ldap = this.state.ldap;
    ldap.basedn = event.target.value;
    this.setState({ ldap: ldap });
  };

  handle_ChangeUsername = (event) => {
    const ldap = this.state.ldap;
    ldap.ldapusername = event.target.value;
    this.setState({ ldap: ldap });
  };

  handle_ChangePassword = (password) => {
    const ldap = this.state.ldap;
    ldap.ldappassword = password;
    this.setState({ ldap: ldap });
  };

  handle_ChangeSearchQuery = (event) => {
    let value = event.target.value ? event.target.value : DEFAULT_LDAP_USER_SEARCH_FILTER;
    // eslint-disable-next-line no-sequences
    this.setState((state) => ((state.ldap.search_query = value), state));
  };

  handle_Submit = () => {
    const ldapToSave = { ...this.state.ldap };
    // Use default filter if search_query is empty
    if (!ldapToSave.search_query || ldapToSave.search_query.trim() === "") {
      ldapToSave.search_query = DEFAULT_LDAP_USER_SEARCH_FILTER;
    }
    this.props.handleSave(ldapToSave);
    this.handleHide();
  };

  renderActions = () => {
    return (
      <button
        type="submit"
        className="mui-btn mui-btn--raised"
        disabled={
          !this.state.ldap.hostname ||
          !this.state.ldap.port ||
          !this.state.ldap.ldapusername ||
          !this.state.ldap.ldappassword ||
          !this.state.ldap.basedn
        }
        onClick={this.handle_Submit}
      >
        Save
      </button>
    );
  };

  render__RequiredOptions = () => {
    return (
      <div>
        <div className="formgroup-element">
          <div className="formgroup-element-title">Enabled</div>
          <div className="formgroup-element-fields">
            <div className="mui-checkbox">
              <Flex alignItems="center">
                <Flex>
                  <Checkbox
                    name="enabled"
                    isChecked={this.state.ldap.enabled}
                    onChange={this.handle_ChangeEnabled}
                    aria-label="Enabled"
                    data-cy="enabled"
                  />
                </Flex>
              </Flex>
            </div>
          </div>
        </div>

        {this.render_GeneralOptions()}
      </div>
    );
  };

  render_GeneralOptions = () => {
    if (!this.state.ldap.enabled) {
      return <div />;
    }

    return (
      <div>
        <div className="formgroup-element">
          <div className="formgroup-element-title">Sync Enabled</div>
          <div className="formgroup-element-fields">
            <div className="mui-checkbox">
              <Flex alignItems="center">
                <Flex>
                  <Checkbox
                    name="syncEnabled"
                    isChecked={this.state.ldap.sync_enabled}
                    onChange={this.handle_ChangeSync}
                    aria-label="Sync Enabled"
                    data-cy="syncEnabled"
                  />
                </Flex>
              </Flex>
            </div>
          </div>
        </div>

        <div className="formgroup-element">
          <div className="formgroup-element-title">Sync Organization Units</div>
          <div className="formgroup-element-fields">
            <div className="mui-checkbox">
              <Flex alignItems="center">
                <Flex>
                  <Checkbox
                    name="syncOrgUnits"
                    isChecked={this.state.ldap.sync_ous}
                    onChange={this.handle_ChangeSyncOUs}
                    aria-label="Sync Organization Units"
                    data-cy="syncOrgUnits"
                  />
                </Flex>
              </Flex>
            </div>
          </div>
        </div>

        <div className="formgroup-element-title">Server Type</div>
        <div className="mui-select">
          <SearchableSelect
            value={this.state.ldap.type}
            clearable={false}
            className={"server-type-search"}
            onChange={this.handle_ChangeMode}
            valueDataMap={[
              ["ad", "Active Directory"],
              ["ol", "OpenLdap"],
              ["ed", "Novell eDirectory"],
              ["custom", "Manual"],
            ]}
            data-cy="serverType"
          />
        </div>

        <div className="formgroup-element-title">Protocol</div>
        <div className="mui-select">
          <SearchableSelect
            value={this.state.ldap.protocol}
            clearable={false}
            className={"server-type-search"}
            onChange={this.handle_ChangeProtocol}
            valueDataMap={[
              ["ldap", "ldap"],
              ["ldaps", "ldaps"],
            ]}
            data-cy="protocol"
          />
        </div>

        <div className="formgroup-element-title">Server Hostname</div>
        <div className="mui-textfield">
          <input type="text" value={this.state.ldap.hostname} onChange={this.handle_ChangeHostname} data-cy="serverHostname" />
        </div>

        <div className="formgroup-element-title">Server Port</div>
        <div className="mui-textfield">
          <input type="number" value={this.state.ldap.port} onChange={this.handle_ChangePort} data-cy="serverPort" />
        </div>

        <div className="formgroup-element-title">Base DN</div>
        <div className="mui-textfield">
          <input type="text" value={this.state.ldap.basedn} onChange={this.handle_ChangeBaseDN} data-cy="baseDN" />
        </div>

        <div className="formgroup-element-title">Username</div>
        <div className="mui-textfield">
          <input type="text" value={this.state.ldap.ldapusername} onChange={this.handle_ChangeUsername} data-cy="username" />
        </div>

        <div className="formgroup-element-title">Password</div>
        <LDAPServerPasswordInput password={this.state.ldap.ldappassword} onChange={this.handle_ChangePassword} data-cy="password" />

        <ConfigFormLabel
          label={"Search Query"}
          tooltip={"This default filter excludes computer accounts and disabled users to sync only active user accounts."}
          containerRef={this.modalRef}
        />
        <div className="mui-textfield">
          <input
            type="text"
            value={this.state.ldap.search_query || DEFAULT_LDAP_USER_SEARCH_FILTER}
            onChange={this.handle_ChangeSearchQuery}
            data-cy="searchQuery"
          />
        </div>

        <div className="mui-checkbox">
          <em>
            <div>Syncing by DN allows you to sync multiple groups with the same name.</div>
            <div>Changing this can invalidate existing filtering rules.</div>
          </em>
          <Flex alignItems="center">
            <Flex>
              <Checkbox
                name="syncByDN"
                isChecked={this.state.ldap.sync_by_dn}
                onChange={this.handle_ChangeSyncByDN}
                aria-label="Sync By DN"
                data-cy="syncByDN"
              />
            </Flex>
            <Flex ml="sp8">
              <label>Sync By DN</label>
            </Flex>
          </Flex>
        </div>
      </div>
    );
  };

  render__ManualOptions = () => {
    if (this.state.ldap.type === "custom") {
      return (
        <div>
          <div className="mui-textfield">
            <Flex alignItems="center">
              <Flex>
                <Checkbox
                  name="userOwnedGroupMembership"
                  isChecked={this.state.ldap.userownedgroupmembership}
                  onChange={this.handle_ChangeUserOwnedGroupMembership}
                  aria-label="User Owned Group Membership"
                />
              </Flex>
              <Flex ml="sp8">
                <label>User Owned Group Membership</label>
              </Flex>
            </Flex>
          </div>
          <div className="mui-textfield">
            <input type="text" value={this.state.ldap.usernameattribute} onChange={this.handle_ChangeUserNameAttribute} />
            <label>Username Attribute</label>
          </div>
          <div className="mui-textfield">
            <input type="text" value={this.state.ldap.managerattribute} onChange={this.handle_ChangeManagerAttribute} />
            <label>Manager Attribute</label>
          </div>
          <div className="mui-textfield">
            <input type="text" value={this.state.ldap.emailattribute} onChange={this.handle_ChangeEmailAttribute} />
            <label>Email Attribute</label>
          </div>
          <div className="mui-textfield">
            <input type="text" value={this.state.ldap.userbase} onChange={this.handle_ChangeUserBase} />
            <label>User Base</label>
          </div>
          <div className="mui-textfield">
            <input type="text" value={this.state.ldap.usergroupattribute} onChange={this.handle_ChangeUserGroupAttribute} />
            <label>User Group Attribute</label>
          </div>
          <div className="mui-textfield">
            <input type="text" value={this.state.ldap.userdnattribute} onChange={this.handle_ChangeUserDnAttribute} />
            <label>User DN Attribute</label>
          </div>
          <div className="mui-textfield">
            <input type="text" value={this.state.ldap.groupdnattribute} onChange={this.handle_ChangeGroupDnAttribute} />
            <label>Group DN Attribute</label>
          </div>
          <div className="mui-textfield">
            <input type="text" value={this.state.ldap.oudnattribute} onChange={this.handle_ChangeOuDnAttribute} />
            <label>OU DN Attribute</label>
          </div>
          <div className="mui-textfield">
            <input type="text" value={this.state.ldap.ounameattribute} onChange={this.handle_ChangeOuNameAttribute} />
            <label>OU Name Attribute</label>
          </div>

          <div className="formgroup-element">
            <div className="formgroup-element-title"> Authenticate with User DN</div>
            <div className="formgroup-element-fields">
              <div className="mui-checkbox">
                <Flex alignItems="center">
                  <Flex>
                    <Checkbox
                      name="authenticateUserUsingDn"
                      isChecked={this.state.ldap.authenticateuserusingsupplieddn}
                      onChange={this.handle_ChangeAuthenticateUserUsingDn}
                      aria-label="Authenticate with User DN"
                    />
                  </Flex>
                </Flex>
              </div>
            </div>
          </div>

          <div className="mui-textfield">
            <input type="text" value={this.state.ldap.groupbase} onChange={this.handle_ChangeGroupBase} />
            <label>Group Base</label>
          </div>
          <div className="mui-textfield">
            <input type="text" value={this.state.ldap.groupnameattribute} onChange={this.handle_ChangeGroupNameAttribute} />
            <label>Group Name Attribute</label>
          </div>
          <div className="mui-textfield">
            <input type="text" value={this.state.ldap.groupmembernameattribute} onChange={this.handle_ChangeGroupMemberNameAttribute} />
            <label>Group Member Name Attribute</label>
          </div>
        </div>
      );
    }

    return <div />;
  };

  render() {
    if (this.props.visible) {
      return (
        <ModalWindow
          title="Edit LDAP Server"
          handleHide={this.handleHide}
          actions={this.renderActions()}
          customclassName="editModal"
          innerRef={this.modalRef}
        >
          <form className="mui-form">
            {this.render__RequiredOptions()}
            {this.render__ManualOptions()}
          </form>
        </ModalWindow>
      );
    }

    return <div />;
  }
}

export default class LdapServers extends React.Component {
  constructor(props, context) {
    super(props, context);
    this.state = {
      ldap: [],
      visible__add_group: false,
      edit__ldap_server: undefined,
      loaded: false,
      changes: false,
      user_merge_priority: 50,
      user_merge_key: UserMergeKey.Email,
      user_merge_attach_only: false,
      error: "",
      showPurgeModal: false,
      isPurging: false,
    };
  }

  handle_load = () => {
    const self = this;
    self.setState({
      loaded: false,
      latestResultStatus: undefined,
    });
    // Every LDAP server shares one appliance-wide run, so per-server status comes
    // from the run's members rather than from each server's own executions.
    Promise.all([listSyncConfigurations([SyncType.Ldaps, SyncType.Ldap]), getLdapRun()])
      .then(([conn, run]) => {
        const nodes = conn.edges.map((edge) => edge.node);
        const servers = nodes.filter((node) => node.syncType === SyncType.Ldaps).map(mapNodeToLdapServer);
        const legacy = nodes.find((node) => node.syncType === SyncType.Ldap);

        servers.forEach((ldap) => {
          ldap.runMember = run?.members.find((member) => member.syncConfigurationID === ldap.id)?.sync;
          ldap.runInFlight = run?.sync.isRunning ?? false;
        });

        // The merge config is shared between all ldap configurations, so read the
        // first one's; the legacy configuration holds it when no server exists yet.
        const mergeConfig = servers[0]?.merge_config ?? (legacy ? mapNodeToLdapServer(legacy).merge_config : undefined);
        const latestStatus = run?.statuses?.[0];

        self.setState({
          loaded: true,
          ldap: servers,
          latestResultStatus: latestStatus ? mapStatusNode(latestStatus, run.id) : undefined,
          user_merge_priority: mergeConfig?.priority || 70,
          user_merge_key: mergeKeyFromConfig(mergeConfig),
          user_merge_expression: mergeConfig?.computed?.expression || undefined,
          user_merge_attach_only: mergeConfig?.attachOnly || false,
        });
      })
      .catch((e) => {
        self.setState({ loaded: true, error: extractSyncError(e, "Error loading LDAP servers.") });
      });
  };

  componentDidMount() {
    this.handle_load();
  }

  currentMergeConfig = () =>
    buildMergeConfig(
      this.state.user_merge_priority,
      this.state.user_merge_key,
      this.state.user_merge_expression,
      this.state.user_merge_attach_only
    );

  handleSaveError = (fallback) => (e) => {
    this.setState({ loaded: true, error: extractSyncError(e, fallback) });
  };

  handler__clickAdd = () => {
    this.setState({
      current_add_new: true,
      // sync-api requires a server type and protocol on create; these are its own
      // defaults for a new server.
      edit__ldap_server: { enabled: true, type: "ad", protocol: "ldap", port: 389 },
      visible__add_permission: true,
    });
  };

  handler__clickCloseAdd = () => {
    this.setState({
      visible__add_permission: false,
      current_add_new: false,
    });
  };

  handle_SaveMergeConfig = () => {
    let self = this;
    if (self.state.ldap.length <= 0) {
      self.setState({
        error: "Require at least one LDAP server configured to change merge configuration.",
      });
      return;
    }
    self.setState({
      error: "",
      changes: false,
    });

    if (
      this.state.user_merge_key === UserMergeKey.Computed &&
      (this.state.user_merge_expression === undefined || this.state.user_merge_expression === "")
    ) {
      this.setState({
        error: "An expression is required if Merge Key is Computed Expression.",
      });
      return;
    }

    updateLdapSharedMergeConfig(mergeConfigToInput(this.currentMergeConfig()))
      .then(() => self.handle_load())
      .catch((e) => {
        self.setState({
          loaded: true,
          changes: true,
          error: extractSyncError(e, "Error attempting to save merge configuration."),
        });
      });
  };

  handle_SyncAll = (event) => {
    event.preventDefault();

    // Executing any one server starts the appliance-wide LDAP run, which visits
    // every server with sync enabled. sync-api refuses a server it cannot execute,
    // so the request names one it will accept.
    const target = this.state.ldap.find((ldap) => ldap.enabled && ldap.sync_enabled && ldap.can_execute);
    if (!target) {
      return;
    }

    let self = this;
    executeSync(target.id)
      .then(() => {
        self.handle_load();
        const manuallySetRunningSyncs = JSON.parse(localStorage.getItem("manuallySetRunningSyncs") || "{}");
        const now = new Date();
        const device = SessionStore.getSelectedDevice();
        manuallySetRunningSyncs[device.concat("_LDAPServersLockout")] = now.getTime() + 60000; // 60 second 'ttl' to lock out this sync in this browser
        localStorage.setItem("manuallySetRunningSyncs", JSON.stringify(manuallySetRunningSyncs));
      })
      .catch(() => {});
  };

  render__buttons = () => {
    const isSupportAdmin = SessionStore.getState().isSupportAdmin();
    const hasLdapServers = this.state.ldap && this.state.ldap.length > 0;
    const buttons = [
      <TableCentricPageButton title="Sync All" onClickHandler={this.handle_SyncAll} data-cy="syncAll" />,
      <TableCentricPageButton title="Refresh" onClickHandler={this.handle_load} data-cy="refresh" />,
      <TableCentricPageButton title="Add LDAP Server" onClickHandler={this.handler__clickAdd} data-cy="addLDAPServer" />,
    ];

    if (isSupportAdmin && hasLdapServers) {
      buttons.push(
        // eslint-disable-next-line jsx-a11y/anchor-is-valid
        <a
          href="#"
          data-cy="purge-btn"
          className="heading_button"
          onClick={(e) => {
            e.preventDefault();
            this.handle_Purge(e);
          }}
          role="button"
          aria-label="Purge Data"
          style={{ backgroundColor: "#d32f2f", color: "#ffffff" }}
        >
          Purge Data
        </a>
      );
    }

    return buttons;
  };

  handle_Delete = (row) => {
    let self = this;
    self.setState({
      loaded: false,
    });
    deleteSyncConfiguration(row["id"])
      .then(() => self.handle_load())
      .catch(this.handleSaveError("Error attempting to delete the LDAP server."));
  };

  handle_Purge = () => {
    this.setState({
      showPurgeModal: true,
    });
  };

  handle_PurgeConfirm = async () => {
    this.setState({ isPurging: true });
    try {
      const device = SessionStore.getSelectedDevice();
      await purgeSyncData("00000000-0000-0000-0000-000000000000", device);
      this.setState({ showPurgeModal: false });
      this.handle_load();
      alert("Purge triggered successfully");
    } catch (error) {
      const errorMessage = error instanceof Error ? error.message : "An unknown error occurred while trying to purge data.";
      alert(`Failed to trigger purge: ${errorMessage}`);
    } finally {
      this.setState({ isPurging: false });
    }
  };

  handle__SaveRule = (rule) => {
    let self = this;
    self.setState({
      loaded: false,
    });
    saveLdapServer(rule, this.currentMergeConfig(), rule["id"])
      .then(() => self.handle_load())
      .catch(this.handleSaveError("Error attempting to save the LDAP server."));
  };

  handle__SaveNew = (rule) => {
    let self = this;
    self.setState({
      loaded: false,
    });
    // Every server shares one merge config, so a new server copies the stored one.
    // The first server carries the Advanced Configuration values instead.
    const merge = this.state.ldap[0]?.merge_config ?? this.currentMergeConfig();
    saveLdapServer(rule, merge)
      .then(() => self.handle_load())
      .catch(this.handleSaveError("Error attempting to save the LDAP server."));
  };

  handle_Edit = (row) => {
    this.setState({
      current_add_new: false,
      edit__ldap_server: row,
      visible__add_permission: true,
    });
  };

  notifyChanged = () => {
    this.setState({ changes: true });
  };

  handle_ChangeUserMergeKey = (value) => {
    this.notifyChanged();
    this.setState({
      user_merge_key: value,
    });
  };

  handle_ChangeUserMergeExpression = (value) => {
    this.notifyChanged();
    this.setState({
      user_merge_expression: value,
    });
  };

  handle_ChangeUserMergeAttachOnly = (value) => {
    this.notifyChanged();
    this.setState({
      user_merge_attach_only: value,
    });
  };

  handle_ChangeUserMergePriority = (value) => {
    this.notifyChanged();

    // Accept empty string or digits only
    if (value === "" || /^[0-9]+$/.test(value)) {
      // Convert to number only for validation purposes
      const numValue = value === "" ? "" : parseInt(value, 10);

      // Allow any intermediate valid input (digits only)
      // For empty or numbers within range 1-99
      if (value === "" || (numValue >= 1 && numValue <= 99)) {
        this.setState({
          user_merge_priority: Number(value),
        });
      }
    }
  };

  statusText = (row) => {
    const now = new Date();
    const device = SessionStore.getSelectedDevice();
    const manuallySetRunningSyncs = JSON.parse(localStorage.getItem("manuallySetRunningSyncs") || "{}");
    const manualStatusExpiry = manuallySetRunningSyncs[device.concat("_LDAPServersLockout")];

    // A server absent from the latest run's members did not take part in it.
    if (manualStatusExpiry > now.getTime()) {
      return "Sync running now";
    } else if (row.runInFlight && row.enabled && row.sync_enabled) {
      return "Sync running now";
    } else if (!row.runMember) {
      return "Not Synced";
    } else if (row.runMember.state === "FAILED" || row.runMember.state === "PARTIAL") {
      return "Failed to sync, reason was " + (row.runMember.message?.trim() || DEFAULT_FAILURE_MESSAGE);
    } else if (row.runMember.state === "RUNNING") {
      return "Sync running now";
    } else if (row.runMember.state === "SUCCEEDED") {
      return "Data was successfully fetched.";
    }

    return "";
  };

  render__content = () => {
    let self = this;
    let columns = [
      {
        title: "Server",
        data: function (row) {
          return row["hostname"];
        },
        sortable: FlexibleTable.sortable__single_caseinsensitive_string_field("hostname"),
        search: FlexibleTable.search__single_string_field("hostname"),
        onclick: undefined,
      },
      {
        title: "Base DN",
        data: function (row) {
          return row["basedn"];
        },
        sortable: FlexibleTable.sortable__single_caseinsensitive_string_field("basedn"),
        search: FlexibleTable.search__single_string_field("basedn"),
        onclick: undefined,
      },
      {
        title: "Status",
        data: (row) => this.statusText(row),
        onclick: undefined,
      },
      {
        title: "Operations",
        data: function (row) {
          return (
            <div>
              <EditButton onClick={() => self.handle_Edit(row)} />
              <Separator />
              <DeleteButton onClick={() => self.handle_Delete(row)} />
            </div>
          );
        },
        class: "operationsColumn",
        onclick: undefined,
      },
    ];

    return (
      <>
        <Box
          sx={{
            marginBottom: "1rem",
            display: "flex",
            justifyContent: "space-between",
            gap: "1rem",
          }}
        >
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              gap: "0.5rem",
              backgroundColor: "white",
              padding: "1rem",
            }}
          >
            <Text fontWeight={"500"}>Advanced Configuration</Text>
            <Skeleton isLoaded={this.state.loaded} fadeDuration={1}>
              <MergeOptionsNoControl
                priorityValue={this.state.user_merge_priority}
                onPriorityChange={this.handle_ChangeUserMergePriority}
                mergeKeyValue={this.state.user_merge_key}
                onMergeKeyChange={this.handle_ChangeUserMergeKey}
                expression={this.state.user_merge_expression}
                onExpressionChange={this.handle_ChangeUserMergeExpression}
                attachOnly={this.state.user_merge_attach_only}
                onAttachOnlyChange={this.handle_ChangeUserMergeAttachOnly}
              />
            </Skeleton>
            <Skeleton isLoaded={this.state.loaded} fadeDuration={1}>
              <Button
                sx={{
                  maxWidth: "150px",
                }}
                onClick={this.handle_SaveMergeConfig}
                disabled={!this.state.loaded || !this.state.changes}
                variant="primary"
              >
                Save
              </Button>
            </Skeleton>
            {this.state.error !== "" && (
              <InlineNotification status="warning" notificationTitle={"Unable to save"} notificationDescription={this.state.error} />
            )}
          </Box>

          <Box
            sx={{
              maxWidth: "450px",
              minWidth: "350px",
              display: "flex",
              flexDirection: "column",
              gap: "0.5rem",
              backgroundColor: "white",
              padding: "1rem",
            }}
          >
            <Text fontWeight={"500"}>Last Sync</Text>
            <Skeleton isLoaded={!!this.state.latestResultStatus} fadeDuration={1} height={this.state.latestResultStatus ? "auto" : "150px"}>
              {this.state.latestResultStatus && (
                <Box flex={1} display={"flex"} flexDirection={"column"}>
                  {this.state.latestResultStatus.status === "Completed" && (
                    <Box gap={"0.5rem"} flex={1} display={"flex"} flexDirection={"column"}>
                      <Text>
                        Completed at {moment(this.state.latestResultStatus.createdAt, formatString).format("HH:mm:ss - ddd Do MMM")} (
                        {moment.duration(moment(this.state.latestResultStatus.createdAt, formatString).diff(moment())).humanize(true)})
                      </Text>
                      {this.state.latestResultStatus.metrics && (
                        <Box marginTop={"auto"} alignItems={"end"} display={"flex"} flexDir={"column"}>
                          {this.state.latestResultStatus.metrics.usersAdded !== null && (
                            <Text>Users Added: {this.state.latestResultStatus.metrics.usersAdded}</Text>
                          )}
                          {this.state.latestResultStatus.metrics.usersUpdated !== null && (
                            <Text>Users Updated: {this.state.latestResultStatus.metrics.usersUpdated}</Text>
                          )}
                          {this.state.latestResultStatus.metrics.usersUnchanged !== null && (
                            <Text>Users Unchanged: {this.state.latestResultStatus.metrics.usersUnchanged}</Text>
                          )}
                          {this.state.latestResultStatus.metrics.usersDeleted !== null && (
                            <Text>Users Deleted: {this.state.latestResultStatus.metrics.usersDeleted}</Text>
                          )}
                          {this.state.latestResultStatus.metrics.groupsAdded !== null && (
                            <Text>Groups Added: {this.state.latestResultStatus.metrics.groupsAdded}</Text>
                          )}
                          {this.state.latestResultStatus.metrics.groupsUpdated !== null && (
                            <Text>Groups Updated: {this.state.latestResultStatus.metrics.groupsUpdated}</Text>
                          )}
                          {this.state.latestResultStatus.metrics.groupsUnchanged !== null && (
                            <Text>Groups Unchanged: {this.state.latestResultStatus.metrics.groupsUnchanged}</Text>
                          )}
                          {this.state.latestResultStatus.metrics.groupsDeleted !== null && (
                            <Text>Groups Deleted: {this.state.latestResultStatus.metrics.groupsDeleted}</Text>
                          )}
                        </Box>
                      )}
                    </Box>
                  )}
                  {this.state.latestResultStatus.status === "Failed" && (
                    <Box>
                      <Text>
                        Failed at {moment(this.state.latestResultStatus.createdAt, formatString).format("HH:mm:ss - ddd Do MMM")} (
                        {moment.duration(moment(this.state.latestResultStatus.createdAt, formatString).diff(moment())).humanize(true)})
                      </Text>
                      <Box>Reason: {this.state.latestResultStatus.message}</Box>
                    </Box>
                  )}
                  {this.state.latestResultStatus.status === "Started" && (
                    <Box>
                      <Text>In Progress</Text>
                      <Text>
                        Started at {moment(this.state.latestResultStatus.createdAt, formatString).format("HH:mm:ss - ddd Do MMM")} (
                        {moment.duration(moment(this.state.latestResultStatus.createdAt, formatString).diff(moment())).humanize(true)})
                      </Text>
                    </Box>
                  )}
                  {this.state.latestResultStatus.status === "Pending" && (
                    <Box>
                      <Text>The Sync is pending and will be started shortly</Text>
                      <Text>
                        Requested at {moment(this.state.latestResultStatus.createdAt, formatString).format("HH:mm:ss - ddd Do MMM")} (
                        {moment.duration(moment(this.state.latestResultStatus.createdAt, formatString).diff(moment())).humanize(true)})
                      </Text>
                    </Box>
                  )}
                </Box>
              )}
            </Skeleton>
          </Box>
        </Box>
        <FlexibleTable columns={columns} data={this.state.ldap} loaded={this.state.loaded} />
      </>
    );
  };

  render() {
    return (
      <>
        <TableLeftPanel>
          <AddEditRule
            visible={this.state.visible__add_permission}
            handleSave={this.state.current_add_new ? this.handle__SaveNew : this.handle__SaveRule}
            handleClose={this.handler__clickCloseAdd}
            ldap={this.state.edit__ldap_server}
          />
          <TableCentricPage
            title="LDAP Servers"
            buttons={this.render__buttons()}
            content={this.render__content()}
            subTitle={
              <Link isExternal href={"https://help.linewize.com/hc/en-gb/articles/5732871324444"}>
                Configuring LDAP Guide
              </Link>
            }
          />
        </TableLeftPanel>
        <PurgeConfirmModal
          isOpen={this.state.showPurgeModal}
          onClose={() => this.setState({ showPurgeModal: false })}
          onConfirm={() => void this.handle_PurgeConfirm()}
          isLoading={this.state.isPurging}
        />
      </>
    );
  }
}
